import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { AppShell } from '@/components/Layout/AppShell';
import { PageWidthProvider } from '@/components/Layout/PageLayout';
import { NotFound } from '@/components/molecules/NotFound';
import { usePermissions } from '@/contexts/auth';
import { useScopedLanguage } from '@/i18n/useScopedLanguage';
import { BioscopeDetailContainer } from '@/routes/shared/BioscopeDetailContainer';
import UserPage from '@/routes/shared/UserManagementPage/UserPage';
import { parsePositiveInt } from '@/utils/parsePositiveInt';

import AuditLog from './routes/AuditLog';
import BioscopeList from './routes/Bioscopes/BioscopeList2';
import Cages from './routes/Cages';
import Client from './routes/Client';
import Clients from './routes/Clients';
import DataShares from './routes/DataShares';

function InternalBioscopeDetail() {
    const bioscopeId = parsePositiveInt(useParams().bioscopeId);

    if (bioscopeId == null) {
        return <NotFound />;
    }

    return <BioscopeDetailContainer bioscopeId={bioscopeId} showPlacementClient />;
}

function Internal() {
    const { canViewAuditLog } = usePermissions();
    // Internal pages are English (WB-125). The user's own language comes back on leaving them,
    // and the switch is not stored as their choice.
    useScopedLanguage('en');

    return (
        <AppShell languageBar={false} showHomeButton={false}>
            {/* Internal admin pages keep the full width they had before PageLayout was capped. */}
            <PageWidthProvider width="full">
                <Routes>
                    <Route path="users" element={<UserPage />} />
                    <Route path="bioscopes/:bioscopeId" element={<InternalBioscopeDetail />} />
                    <Route path="bioscopes" element={<BioscopeList />} />
                    <Route path="cages" element={<Cages />} />
                    <Route path="clients" element={<Clients />} />
                    <Route path="clients/:clientId" element={<Client />} />
                    <Route path="data-shares" element={<DataShares />} />
                    {canViewAuditLog && <Route path="audit-log" element={<AuditLog />} />}
                    <Route index element={<Navigate to="/internal/bioscopes" replace />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </PageWidthProvider>
        </AppShell>
    );
}

export default Internal;
export { Internal };
